import React from "react";

const ButtonLoader = ({ 
  size = "small", 
  variant = "primary",
  className = "" 
}) => {
  const sizeClasses = {
    small: "w-4 h-4",
    medium: "w-5 h-5",
    large: "w-6 h-6"
  };

  const variantClasses = {
    primary: "border-white",
    secondary: "border-gray-600",
    success: "border-white",
    warning: "border-white",
    danger: "border-white"
  };

  return (
    <div className={`inline-block ${className}`}>
      <div className={`${sizeClasses[size]} border-2 border-transparent border-t-current rounded-full animate-spin ${variantClasses[variant]}`}></div>
    </div>
  );
};

export default ButtonLoader; 